import React, { FunctionComponent } from "react";
import {
  AppBar,
  Box,
  Toolbar,
} from "@mui/material";
import { IMAGES } from "../../utils/constants";

const GuestHeader: FunctionComponent = () => {
  
  return (
    <AppBar position="static" elevation={0} sx={{ backgroundColor: "#f9fcfd", color: "black" }}>
      <Toolbar sx={{ justifyContent: "space-between", px: 2, height: 75 }}>

        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <img src={IMAGES.barksdaleLogo} alt="Logo" height={50} />

          <Box sx={{ width: "2px", height: 40, backgroundColor: "#d01e42", mx: 1 }} />

          <img src={IMAGES.extranetLogo} alt="Logo" height={50} />

          <Box sx={{ display: "flex", alignItems: "center", gap: 2, ml: 3 }}>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default GuestHeader;
